import { Box, Button, Drawer, TextField } from "@mui/material";
import React, { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../services/client/rest";

function AddUsers({
  open,
  onClose,
  serialNumber,
  RefreshAzureUsers,
}: {
  open: boolean;
  onClose: any;
  serialNumber: any;
  RefreshAzureUsers: any;
}) {
  const [openDrawer, SetOpenDrawer] = React.useState<any>(open);
  const [currentRow, SetCurrentRow] = useState([] as any);

  var bearer = "Bearer " + localStorage.getItem("token");
  const headers = {
    Authorization: bearer,
  };

  function OnSaveClick() {
    const request = {
      serialNumber: serialNumber,
      numUsers: currentRow.numUsers,
      csiPassword: currentRow.csiPassword,
    };
    let url = BASE_URL + "Customer/AddUsers";

    axios
      .post(url, request, {
        headers,
      })
      .then((response) => {
        SetOpenDrawer(false);
        RefreshAzureUsers();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  React.useEffect(() => {
    SetOpenDrawer(open);
  }, [open]);

  function SetValue(key: string, value: any) {
    currentRow[key] = value;
  }

  return (
    <Box>
      <Drawer
        PaperProps={{ style: { width: "auto" } }}
        anchor="right"
        open={openDrawer}
        onClose={() => onClose(0)}
        variant={"temporary"}
      >
        <Box style={{ padding: "5px 10px", marginTop: "15px" }}>
          <Box style={{ width: "100%" }}>
            <Box sx={{ minWidth: 20, marginTop: "12px" }}>
              <TextField
                required
                id="filled-number"
                label="Number of Users to Add"
                onChange={(e: any) => {
                  SetValue("numUsers", e.target.value);
                }}
                type="number"
                variant="outlined"
              />
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <TextField
                required
                id="outlined-required"
                label="Password"
                onChange={(e: any) => {
                  SetValue("csiPassword", e.target.value);
                }}
                style={{ width: "300px" }}
                type="password"
              />
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{ padding: "10px", border: "0px solid red" }}
          >
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={OnSaveClick}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}
export default AddUsers;
